<template>
  <a-card class="loading">
    <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px">
        <span style="font-weight: bold;font-size: 16px">
          设备信息:
        </span>
      <a-button type="primary" @click="update">刷新</a-button>
    </div>
    <a-spin :spinning="single.currentCode.info.length === 0">
      <div v-if="single.currentCode.info.length !== 0">
        <a-descriptions bordered :size="'small'" :column="2">
          <a-descriptions-item label="升级版本" v-if="single.currentCode.netType === '4G'">
            {{ single.currentCode.info[13] || '暂无' }}
          </a-descriptions-item>
          <a-descriptions-item label="升级版本" v-else>{{ single.currentCode.info[36] || '暂无' }}</a-descriptions-item>
          <a-descriptions-item label="硬件版本">{{ single.currentCode.info[0] || '暂无' }}</a-descriptions-item>
          <a-descriptions-item label="开机时间">{{ single.currentCode.info[1] || '暂无' }}</a-descriptions-item>
          <a-descriptions-item label="4G卡号" v-if="single.currentCode.netType === '4G'">
            {{ single.currentCode.info[26] || '暂无' }}
          </a-descriptions-item>
          <a-descriptions-item label="4G-IP" v-if="single.currentCode.netType === '4G'">
            {{ single.currentCode.info[3] || '暂无' }}
          </a-descriptions-item>
          <a-descriptions-item label="WIFI-IP" v-else>{{
              single.currentCode.info[14].split(' addr:')[1] || '暂无'
            }}
          </a-descriptions-item>
          <a-descriptions-item label="设备Id">{{ single.currentCode.info[5] || '暂无' }}</a-descriptions-item>
          <a-descriptions-item label="主节点二维码">
        <span v-if="!single.currentCode.info[8]">
          暂无
        </span>
            <u v-else style="color: #0c16ea;cursor: pointer"
               @click="single.changeCurrentCode(single.currentCode.info[8],dev.devListInfo.deviceList[index].devices)">
              {{ single.currentCode.info[8] }}
            </u>
          </a-descriptions-item>
          <a-descriptions-item label="sd卡状态">
            <span v-if="single.currentCode.info[15] === '' || single.currentCode.info[15] === 'null'">暂无</span>
            <span v-else style="color: #C00">{{ getSdCard(single.currentCode.info[15]) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="设置wifi信道" v-if="single.currentCode.netType === '4G'">
            <a-space>
              <a-select v-model:value="single.currentCode.info[9]"
                        ref="select"
                        style="width: 80px">
                <a-select-option value="auto">auto</a-select-option>
                <a-select-option v-for="i in 11" :key="i" :value="i">{{ i }}</a-select-option>
              </a-select>
              <a-button @click="commitAuto">提交</a-button>
            </a-space>
          </a-descriptions-item>
          <a-descriptions-item label="AP-SSID">
            <a-space>
              <a-input placeholder="AP-SSID" v-model:value="single.currentCode.info[18]"/>
              <a-button @click="resetNetwork">reset</a-button>
            </a-space>
          </a-descriptions-item>
          <a-descriptions-item label="WIFI-SSID">
            <a-space>
              <a-input placeholder="WIFI-SSID" v-model:value="single.currentCode.info[35]"/>
              <a-button @click="setWifiShindo">提交</a-button>
              <a-tooltip title="设备重启" color="#2db7f5">
                <a-button @click="single.rebootDev">reboot</a-button>
              </a-tooltip>
            </a-space>
          </a-descriptions-item>
<!--          <a-descriptions-item label="所属项目ID">{{-->
<!--              single.currentCode.info[4] !== '0' ? single.currentCode.info[4] : '无归属'-->
<!--            }}-->
<!--          </a-descriptions-item>-->
        </a-descriptions>
      </div>
      <div v-else class="loading"></div>
    </a-spin>
  </a-card>
</template>
<script setup>
import singleDev from "@/stores/singleDev";
import devStore from "@/stores/devStore";
import {ref} from "vue"
import load from "@/common/load";

let single = singleDev();
let dev = devStore();

// 刷新
let update = () => {
  single.changeCurrentCode(single.currentCode.qrCode)
}

let index = 0;
if (dev.devListInfo.deviceList.length === 1) {
  index = 0;
} else {
  for (let i = 0; i < dev.devListInfo.deviceList.length; i++) {
    for (let j = 0; j < dev.devListInfo.deviceList[i].devices.length; j++) {
      if (dev.devListInfo.deviceList[i].devices[j].uniqueCode === single.currentCode.qrCode) {
        index = i
        break;
      }
    }
  }
}
// 获取sd卡数据
let getSdCard = (msg) => {
  console.log(msg)
  if (msg == '') return
  let sd_payload = msg.split(' ');
  return `${sd_payload[2]}(${sd_payload[1]})  已用${sd_payload[5]}(${sd_payload[3]}) 剩余 ${sd_payload[4]}`
}
console.log(single.currentCode.info)
// 信道
let shindo = ref("");
let apId = ref("");
let wifiId = ref("");
shindo.value = single.currentCode.info[9] !== '0' ? single.currentCode.info[9] : 'auto';
apId.value = single.currentCode.info[18];
wifiId.value = single.currentCode.info[35];
// 提交信道
let commitAuto = () => {
  if (shindo.value !== single.currentCode.info[9]) {
    let msg = `uci set wireless.radio0.region=1 && uci set wireless.radio0.channel=${single.currentCode.info[9] === 'auto' ? single.currentCode.info[9] : Number(single.currentCode.info[9])} && uci commit && echo uciwifichok`
    single.obtainTheDeviceNetworkingType('', function (topic, msg) {
      console.log(topic)
      console.log(msg)
      let timeout = setTimeout(() => {
        load.error("wifi信道设置超时...");
        single.currentCode.info[9] = shindo.value;
      }, 5000)
      if (msg.trim() === 'uciwifichok') {
        load.success("wifi信道设置成功");
        clearTimeout(timeout)
        shindo.value = single.currentCode.info[9];
      }
    }, true, msg)
  } else {
    load.confirm(`当前已经是${shindo.value}信道`)
  }
}
// 网络重置
let resetNetwork = () => {
  let msg = 'killall -s 9 ap_client > /dev/null 2>&1 ; ((sleep 1 ; /etc/init.d/network restart) &) && echo etcnetresetok';
  single.obtainTheDeviceNetworkingType('', function (topic, msg) {
    console.log(topic)
    console.log(msg)
    if (msg.trim() === 'etcnetresetok') {
      load.success("网络重置开始...");
      shindo.value = single.currentCode.info[9];
    }
  }, true, msg)
}
// 设置子节点wifi
let setWifiShindo = () => {
  console.log(wifiId.value)
  if (wifiId.value === '') return load.error("当前值为空");
  if (wifiId.value !== single.currentCode.info[35]) {
    let msg = `(sed -i "s/WIFI_SSID=.*/WIFI_SSID=${single.currentCode.info[35]}/g" /app/userdata/ifcfg.wlan0) && echo uciwifissidok`
    single.obtainTheDeviceNetworkingType('', function (topic, msg) {
      console.log(topic)
      console.log(msg)
      let timeout = setTimeout(() => {
        load.error("wifi_ssid设置超时...");
        single.currentCode.info[17] = wifiId.value;
      }, 5000)
      if (msg.trim() === 'uciwifissidok') {
        load.success("wifi_ssid设置成功");
        clearTimeout(timeout);
        wifiId.value = single.currentCode.info[17];
      }

    }, true, msg)
  } else {
    load.confirm(`当前已经是${wifiId.value}`)
  }
}
</script>
<style scoped lang="scss">
.loading {
  display: flex;
  min-width: 30vw;
  min-height: 30vh;
  align-items: center;
  justify-content: center;
}
</style>
